var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "assessment_main" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.productFlag == 3
      ? _c("ul", [
          _vm.isStudent || _vm.$_has("zledu.gxzx.zhsxappsj:sj")
            ? _c(
                "li",
                [
                  _c("img", {
                    staticClass: "app_logo",
                    staticStyle: { height: "30px" },
                    attrs: { src: require("../img/znsj-logo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "app_bg",
                    attrs: { src: require("../img/znsj-bg.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.entrySys("sj")
                        }
                      }
                    },
                    [_vm._v("进入系统")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("img", {
                staticClass: "app_bg",
                attrs: { src: require("../img/znsj-bg.png"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text" }, [_vm._v("政府审计案例库")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.jumpLink("sjalk")
                    }
                  }
                },
                [_vm._v("进入系统")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("img", {
                staticClass: "app_bg",
                attrs: { src: require("../img/znsj-bg.png"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text" }, [
                _vm._v("中央纪委国家监委法规库")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.jumpLink("jwfgk")
                    }
                  }
                },
                [_vm._v("进入系统")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("img", {
                staticClass: "app_bg",
                attrs: { src: require("../img/znsj-bg.png"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text" }, [_vm._v("审计署法律法规库")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.jumpLink("sjflfgk")
                    }
                  }
                },
                [_vm._v("进入系统")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("img", {
                staticClass: "app_bg",
                attrs: { src: require("../img/znsj-bg.png"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text" }, [
                _vm._v("证券期货法规数据库系统")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.jumpLink("zqfgsjk")
                    }
                  }
                },
                [_vm._v("进入系统")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("img", {
                staticClass: "app_bg",
                attrs: { src: require("../img/znsj-bg.png"), alt: "" }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text" }, [_vm._v("财政部法律法规库")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.jumpLink("czflfgk")
                    }
                  }
                },
                [_vm._v("进入系统")]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.productFlag == 4
      ? _c("ul", [
          _vm.isStudent || _vm.$_has("zledu.gxzx.zsrwappsj:sj")
            ? _c(
                "li",
                [
                  _c("img", {
                    staticClass: "app_logo",
                    staticStyle: { height: "30px" },
                    attrs: { src: require("../img/znsj-logo.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "app_bg",
                    attrs: { src: require("../img/znsj-bg.png"), alt: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.entrySys("sj")
                        }
                      }
                    },
                    [_vm._v("进入系统")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "assessment_title" }, [
      _c("h2", [_vm._v("智能审计")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d588de8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d588de8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/appCenter/components/audit.vue
// module id = null
// module chunks = 